import { SavedView } from '@core/models';

export namespace ViewActions {
  export class SetViews {
    static readonly type = '[Jupiter] Set Views';

    constructor() {}
  }

  export class SetView {
    static readonly type = '[Jupiter] Set View';

    constructor(public viewId: number) {}
  }

  export class ClearView {
    static readonly type = '[Jupiter] Clear View';

    constructor() {}
  }

  export class AddView {
    static readonly type = '[Jupiter] Add View';

    constructor(public view: Partial<SavedView>) {}
  }

  export class UpdateView {
    static readonly type = '[Jupiter] Update View';

    constructor(
      public viewDefinition: string,
      public filterDefinition: string,
    ) {}
  }

  export class UpdateViewName {
    static readonly type = '[Jupiter] Update View Name';

    constructor(public name: string) {}
  }

  export class DuplicateView {
    static readonly type = '[Jupiter] Duplicate View';

    constructor() {}
  }

  export class DeleteView {
    static readonly type = '[Jupiter] Delete View';

    constructor() {}
  }
}
